module.exports = __webpack_public_path__ + "img/entry_form_close.82bdf1c4.svg";